import { useRef, useEffect, useState } from "react"
import Layout from '../../Layout'
import RightSidebar from "components/Checkout/RightSidebar"
import ShippingInfo from "components/Checkout/ShippingInfo"
import CheckoutProductList from "components/Checkout/CheckoutProductList"
import DeliveryMethod from "components/Checkout/DeliveryMethod"
import PaymentMethod from "components/Checkout/PaymentMethod"
import OrderNote from "components/Checkout/OrderNote"

export default function Checkout() {
    useEffect(() => {
        document.body.classList.add("NoneFooter");

        return () => {
            document.body.classList.remove("NoneFooter");
        };
    }, []);
    return (
        <Layout>
            <div className="MuiContainer-root MuiContainer-disableGutters MuiContainer-maxWidthLg mobile-mt-24 ">
                <div className="styles_wrapper_gray__f8P4_">
                    <div className="styles_payment_wrapper__R7Bz9">
                        <div className="MuiGrid-root styles_payment_grid__kN77N MuiGrid-container">
                            <div className="MuiGrid-root styles_itemLeft__fZHT_ MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-9">
                                <div id="delivery__info_form" className="styles_wMax__iGEzJ">
                                    <ShippingInfo />
                                </div>
                                <CheckoutProductList />
                                <DeliveryMethod />
                                <PaymentMethod />
                                <OrderNote />
                            </div>
                            <RightSidebar />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
